/** The attribute every tour anchor carries: `data-tour="shell.search"`. */
export const TOUR_ANCHOR_ATTR = 'data-tour';
//# sourceMappingURL=types.js.map